import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore"
import { POTENCIA_MINIMA_ENGENHARIA } from "../constants"

interface RedirecionarParaProjetoVerticalProps {
  onNegation: () => void
}

export function redirecionarParaProjetosEspeciais({ onNegation }: RedirecionarParaProjetoVerticalProps) {
  confirmationDialog.setup({
    title: 'Atenção!',
    content: (
      <>
        <p>Projetos com potência maior que {POTENCIA_MINIMA_ENGENHARIA} kWp devem ser registrados no portal de relacionamento.</p>
      </>
    ),
    onClose: () => {
      confirmationDialog.close()
    },
    onNegation: () => {
      confirmationDialog.close()
      if (typeof onNegation === 'function') onNegation()
    },
    onConfirmation: () => {
      confirmationDialog.close()
      if (typeof onNegation === 'function') onNegation()
    },
    yesText: 'Já sei fazer registro de projetos',
    onlyConfirm: true
  })

  confirmationDialog.open()
}